export default "__VITE_ASSET__ChUzbYLo__"